<template>
  <div>
    <Header :title="title"></Header>
    <NOdata title="功能暂未开放~"></NOdata>   
  </div>
</template>

<script>

export default {
  data() {
    return {
      title:''
    };
  },
  created(){
      this.title=this.$route.query.title
  }
};
</script>



// WEBPACK FOOTER //
// src/components/newPages/nodata.vue